<template>
  <div class="project-item">
    <app-project-form
      :project="project"
      :patient="project.patient"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AppProjectForm } from "../shared/components";

export default {
  name: "AppProjectsItem",
  components: { AppProjectForm },

  data() {
    return {
      project: null
    };
  },

  computed: {
    ...mapGetters({
      getProjectByUuid: "projects/getProjectByUuid"
    })
  },

  created() {
    this.project = this.getProjectByUuid(this.$route.params.uuid);
  },

  methods: {}
};
</script>

<style></style>
